module.exports = __webpack_public_path__ + "img/add_invoice_client.fb269953.svg";